import { useAppDispatch, useAppSelector } from './store';
import { updateToken } from './authSlice';
import { updateLanguage, initUser } from './userSlice';
import { updateAvailableLanguages } from './i18nSlice';
import { type PhraseLocale } from '../api/translations';
import { type UserState } from './store.type';

export const useAuthStore = () => {
  const dispatch = useAppDispatch();
  return {
    token: useAppSelector(state => state.auth.token),
    updateToken: (payload: string) => dispatch(updateToken(payload)),
  };
};

export const useUserStore = () => {
  const dispatch = useAppDispatch();
  return {
    displayName: useAppSelector(state => state.user.displayName),
    preferredLanguage: useAppSelector(state => state.user.preferredLanguage),
    initUser: (payload: UserState) => dispatch(initUser(payload)),
    updateLanguage: (payload: string) => dispatch(updateLanguage(payload)),
  };
};

export const useI18nStore = () => {
  const dispatch = useAppDispatch();
  return {
    availableLanguages: useAppSelector(state => state.i18n.availableLanguages),
    updateAvailableLanguages: (payload: PhraseLocale[]) => dispatch(updateAvailableLanguages(payload)),
  };
};
